import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Shield, LogIn } from 'lucide-react';

const AdminLogin = () => {
  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/admin';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <Card className="w-full max-w-md bg-slate-800/50 border-slate-700/50">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 bg-[#e2e8f0]/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Shield className="w-8 h-8 text-[#e2e8f0]" />
          </div>
          
          <Badge className="mb-4 bg-[#e2e8f0] text-slate-800 border-0 px-3 py-1 text-xs font-semibold">
            ADMIN ACCESS
          </Badge>
          
          <h1 className="text-2xl font-bold text-white mb-2 heading-font">
            Admin Dashboard
          </h1>
          
          <p className="text-gray-400 mb-8 text-sm">
            Sign in with your Google account to access the quote requests dashboard.
          </p>

          <Button
            onClick={handleGoogleLogin}
            className="w-full bg-white hover:bg-gray-100 text-slate-900 font-medium h-12"
            data-testid="google-login-btn"
          >
            <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
              <path
                fill="currentColor"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="currentColor"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="currentColor"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="currentColor"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Continue with Google
          </Button>

          <p className="text-gray-500 text-xs mt-6">
            Only authorized accounts can access admin features.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
